import React, { useMemo } from 'react';

import { UAParser } from '@ua-parser-js/pro-enterprise';
import { QRCodeSVG } from 'qrcode.react';

import AppStoreBadge from '@/assets/for_parents_app/app-store-badge.svg?react';
import ForParentsAppIcon from '@/assets/for_parents_app/for_parents_app_icon.svg?react';
import GooglePlayBadge from '@/assets/for_parents_app/google-play-badge.svg?react';

import styles from './ForParentsAppInformation.module.scss';

import type SvgrComponent from '*.svg?react';

const DownloadItem: React.FC<{
  badgeSvgrComponent: typeof SvgrComponent;
  url: string;
  ariaLabelStoreName: string;
}> = ({ badgeSvgrComponent: BadgeSVG, url, ariaLabelStoreName }) => {
  const isShowQrCode = useMemo(() => {
    const device = new UAParser().getDevice();
    return device.type !== 'mobile';
  }, []);

  return (
    <div className={styles.download_item}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${ariaLabelStoreName}からダウンロード`}
      >
        <BadgeSVG className={styles.download_badge} />
      </a>
      {isShowQrCode && (
        <QRCodeSVG
          value={url}
          className={styles.download_qr_code}
          aria-label={`${ariaLabelStoreName}のダウンロードページへのQRコード`}
        />
      )}
    </div>
  );
};

const ForParentsAppInformation: React.FC = () => (
  <div className={styles.root}>
    <div className={styles.description_container}>
      <ForParentsAppIcon className={styles.app_icon} />
      <div className={styles.description_text_container}>
        <p className={styles.description_headline}>学校からの新着連絡を</p>
        <p className={styles.description_cta}>アプリなら通知でお知らせ</p>
      </div>
    </div>
    <div className={styles.download_info_container}>
      <DownloadItem
        badgeSvgrComponent={AppStoreBadge}
        url="https://itunes.apple.com/jp/app/id6757412233?mt=8"
        ariaLabelStoreName="App Store"
      />
      <DownloadItem
        badgeSvgrComponent={GooglePlayBadge}
        url="https://play.google.com/store/apps/details?id=jp.co.recruit.for_parents"
        ariaLabelStoreName="Google Play"
      />
    </div>
  </div>
);

export default ForParentsAppInformation;
